<template>
    <div id="emrClass">
        <sidebar :content="sidebarData"></sidebar>
        <router-view></router-view>
    </div>
</template>
<script>
import sidebar from "@/components/sidebar";
export default {
  name: "emrClass",
  components: {
    sidebar
  },
  data() {
    return {
      sidebarData: {
        title: "应急课堂",
        sub: [
          {
            title: "应急常识",
            sub: [],
            url: "/emrClass/knowledge"
          },
          {
            title: "在线微课",
            sub: [
              {
                title:"应急视频",
                url:"/emrClass/onlineClass"
              },
              {
                title:'应急讲座',
                url:"/emrClass/lectures"
              },
              {
                title:'应急课堂',
                url:"/emrClass/eclass"
              }
            ],
            url: "/emrClass/onlineClass"
          }
        ]
      }
    };
  }
};
</script>
<style lang="scss" scoped>
#emrClass {
  display: flex;
    width: 80%;
    margin: 0 auto;
    padding: 40px 0 160px 0;
}
</style>


